// Maidenhead locator math — port of refdata/locator.go for the browser.

const FIELD = 'A'.charCodeAt(0);
const SUB = 'A'.charCodeAt(0);

export function locatorToLatLon(loc) {
  if (!loc || (loc.length !== 4 && loc.length !== 6 && loc.length !== 8)) {
    throw new Error(`bad locator: ${loc}`);
  }
  const s = loc.toUpperCase();
  const lonField = s.charCodeAt(0) - FIELD;
  const latField = s.charCodeAt(1) - FIELD;
  const lonSquare = +s[2];
  const latSquare = +s[3];
  let lon = lonField * 20 - 180 + lonSquare * 2;
  let lat = latField * 10 - 90 + latSquare;
  if (s.length === 4) return [lat + 0.5, lon + 1];
  const subLon = s.charCodeAt(4) - SUB;
  const subLat = s.charCodeAt(5) - SUB;
  lon += subLon * (2 / 24);
  lat += subLat * (1 / 24);
  if (s.length === 6) return [lat + (1 / 24) / 2, lon + (2 / 24) / 2];
  const extLon = +s[6];
  const extLat = +s[7];
  lon += extLon * (2 / 24 / 10);
  lat += extLat * (1 / 24 / 10);
  return [lat + (1 / 24 / 10) / 2, lon + (2 / 24 / 10) / 2];
}

// Fast validator for the settings panel.
export function isValidLocator(loc) {
  if (!loc) return false;
  const s = loc.toUpperCase();
  if (![4, 6, 8].includes(s.length)) return false;
  if (!/^[A-R]{2}[0-9]{2}([A-X]{2}([0-9]{2})?)?$/.test(s)) return false;
  return true;
}
